
import { Dialog, DialogBackdrop, DialogPanel }  from '@headlessui/react';
import { useForm, Controller }                  from "react-hook-form";
import Select                                   from 'react-select';
import { isEmail }                              from "validator";
import { useEffect }                            from 'react';
import '../../styles/LoadingTable.css'

/**
 * Formulário de usuário do backoffice — serve para criar e para editar.
 *
 * Na edição os campos de senha não aparecem: a senha do usuário não passa por
 * esta tela nem pela rota de edição. Quem esqueceu a senha usa o botão
 * "Redefinir senha" da tabela, que gera uma provisória e deixa registro de
 * quem redefiniu a senha de quem.
 */
function UserForm({ isOpen, onClose, isEditMode, onSubmit, groups, railways, initialValues, loading, salvando }){

    const { control, register, handleSubmit, watch, reset, formState: { errors } } = useForm();
    const watchPassword = watch("password");

    const acharOpcao = (opcoes, valor) =>
        (opcoes || []).find(opcao => opcao.value === valor) || null

    // Preenche o formulário quando o modal abre e quando as listas de grupo e
    // ferrovia terminam de carregar — sem isto, abrir a edição antes do fetch
    // deixaria os dois selects vazios.
    useEffect(() => {

        reset({
            fullName:   initialValues?.fullName || '',
            email:      initialValues?.email    || '',
            username:   initialValues?.username || '',
            userGroupId: acharOpcao(groups, initialValues?.userGroupId)
                         || (groups || [])[0]
                         || null,
            railwayId:  acharOpcao(railways, initialValues?.railwayId)
                         || acharOpcao(railways, 4)   // FIPS, o padrão do cadastro
                         || (railways || [])[0]
                         || null,
            password: '',
            passwordConfirmation: ''
        })

    }, [initialValues, groups, railways, reset])

    return(

         <Dialog open={isOpen} onClose={onClose} className="relative z-[100]">

                <DialogBackdrop transition className="fixed inset-0 bg-bg-backdrop transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"/>

                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">

                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">

                        <DialogPanel transition className="w-[505px] relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8  data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95">

                            <div className="app-container">


                                <header className="bg-azul-profundo-m flex justify-between items-center pl-4 pr-1 py-3">

                                    <h2 className="text-white text-[1rem] leading-7 font-semibold">{!isEditMode ? "Novo " : "Editar "}Usuário</h2>
                                    <button onClick={onClose} className="text-[1.2rem] text-white hover:text-gray-200 pr-2 ">×</button>

                                </header>

                                {/* Inputs */}
                                <div className="px-4 pb-4 pt-5 sm:p-6 sm:pb-4 flex flex-col gap-[10px]">


                                    {/* Grupos */}
                                    <div className="flex flex-col w-full">
                                        <span className="text-sm font-semibold">Grupo:</span>
                                        { loading ? (

                                        <div className='one w-full h-[38px] rounded-[5px] border-[solid] border-[1px] border-[#E0E0E0]'> </div>

                                        ) : (

                                        <Controller
                                            control={control}
                                            name="userGroupId"
                                            rules={{ required: true }}
                                            render={({ field }) => (
                                                <Select
                                                    {...field}
                                                    inputId="userGroupId"
                                                    isSearchable={false}
                                                    options={groups}
                                                    classNamePrefix="select"
                                                />
                                            )}
                                        />
                                        )}

                                    </div>

                                    {/* Nome */}
                                    <div className="flex flex-col w-full">
                                        <span className="text-sm font-semibold">Nome Completo:</span>
                                        <input
                                            className={`rounded-[3px] px-3 py-2 focus:outline-none focus:border-blue-500 ${errors?.fullName ? "border border-red-300" : "border border-gray-300"}`}
                                            type="text"
                                            {...register("fullName", { required: true })}
                                        />

                                    {errors?.fullName?.type === "required" && (
                                        <p className="text-[red] text-[0.8rem]">Preencha o nome.</p>
                                    )}
                                    </div>

                                    {/* e-mail */}
                                    <div className="flex flex-col w-full">
                                        <span className="text-sm font-semibold">E-mail:</span>
                                        <input
                                            className={`rounded-[3px] px-3 py-2 focus:outline-none focus:border-blue-500 ${errors?.email ? "border border-red-300" : "border border-gray-300"}`}
                                            type="email"

                                            {...register("email", {
                                                required: true,
                                                validate: (value) => isEmail(value)
                                            })}
                                        />

                                        {errors?.email?.type === "required" && (
                                            <p className="text-[red] text-[0.8rem]">Email é obrigatório.</p>
                                        )}

                                        {errors?.email?.type === "validate" && (
                                            <p className="text-[red] text-[0.8rem]  ">Email inválido.</p>
                                        )}
                                    </div>


                                    {/* Ferrovia */}
                                    <div className="flex flex-col w-full">
                                        <span className="text-sm font-semibold">Ferrovia:</span>
                                        { loading ? (

                                        <div className='one w-full h-[38px] rounded-[5px] border-[solid] border-[1px] border-[#E0E0E0]'> </div>

                                        ) : (

                                        <Controller
                                            control={control}
                                            name="railwayId"
                                            rules={{ required: true }}
                                            render={({ field }) => (
                                                <Select
                                                    {...field}
                                                    inputId="railwayId"
                                                    isSearchable={false}
                                                    options={railways}
                                                    classNamePrefix="select"
                                                />
                                            )}
                                    />
                                    )}

                                    </div>

                                    {/* Username */}
                                    <div className="flex flex-col w-full">
                                        <span className="text-sm font-semibold">Username:</span>
                                        <input
                                            className={`rounded-[3px] px-3 py-2 focus:outline-none focus:border-blue-500 ${errors?.username ? "border border-red-300" : "border border-gray-300"}`}
                                            type="text"

                                            {...register("username", {
                                                required: true,

                                            })}
                                        />

                                        {errors?.username?.type === "required" && (
                                            <p className="text-[red] text-[0.8rem]">Username é obrigatório.</p>
                                        )}

                                    </div>


                                    {/* Senha — só na criação. Na edição a senha não é
                                        alcançável por esta tela: use "Redefinir senha". */}
                                    {!isEditMode && (
                                    <>
                                    <div className="flex flex-col w-full">
                                        <span className="text-sm font-semibold">Senha:</span>
                                        <input
                                            className={`rounded-[3px] px-3 py-2 focus:outline-none focus:border-blue-500 ${errors?.password ? "border border-red-300" : "border border-gray-300"}`}
                                            type="password"
                                            {...register("password", { required: true, minLength: 12  })}

                                        />

                                        {errors?.password?.type === "required" && (
                                            <p className="text-[red] text-[0.8rem]">Preencha a senha.</p>
                                        )}

                                        {errors?.password?.type === "minLength" && (
                                            <p className="text-[red] text-[0.8rem]">
                                            A senha precisa ter no mínimo 12 caracteres.
                                            </p>
                                        )}

                                    </div>

                                    {/* confirme a senha */}
                                    <div className="flex flex-col w-full">
                                        <span className="text-sm font-semibold">Confirme a Senha:</span>
                                        <input
                                            type="password"
                                            className={`rounded-[3px] px-3 py-2 focus:outline-none focus:border-blue-500 ${errors?.passwordConfirmation ? "border border-red-300" : "border border-gray-300"}`}

                                            {...register(
                                                "passwordConfirmation", {
                                                    required: true,
                                                    validate: (value) => value === watchPassword
                                            })}

                                        />

                                        {errors?.passwordConfirmation?.type === "required" && (
                                            <p className="text-[red] text-[0.8rem]">Confime a senha.</p>
                                        )}

                                        {errors?.passwordConfirmation?.type === "validate" && (
                                            <p className="text-[red] text-[0.8rem]">Confirmação de senha não iguais.</p>
                                        )}

                                    </div>
                                    </>
                                    )}

                                    {isEditMode && (
                                        <p className="text-sm text-gray-600 border-l-2 border-gray-300 pl-3">
                                            A senha não é alterada por aqui. Para dar uma senha nova
                                            a esta pessoa, use <b>Redefinir senha</b> na tabela.
                                        </p>
                                    )}
                                </div>


                                {/* Buttons */}
                                <div className="w-full bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">

                                    <button
                                        type="submit"
                                        disabled={salvando}
                                        onClick={() => handleSubmit(onSubmit)()}
                                        className="btn btn-azul-prof w-[100%] text-[1.125rem] disabled:cursor-wait disabled:opacity-60"
                                    >
                                        {salvando ? 'Salvando...' : 'Salvar'}
                                    </button>

                                </div>

                            </div>
                        </DialogPanel>
                    </div>

                </div>

                </Dialog>

    )
}

export default UserForm;
